module.exports = __webpack_public_path__ + "static/2-535370f4a7878382796da129e673473c.png";